import React from 'react';
import {makeContractsByKennitala, getDescriptiveContractName, formatKennitala } from '../../utils'
import ContractsOverviewDetailedContractInfo from '../contracts-overview-detailed-contract-info'
import { SvgArrowIcon } from '../svg';
import Alert from 'react-bootstrap/Alert';

class AddPhotoId extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            multIds: {}
        }
    }

    getInitialValues(customerId) {
        return this.props.infoCollection.data.find(f => f.customerId === customerId)
    }

    getCustNameAndKennitala(kennitala) {
        let ktNamePair = Object.entries(this.props.customers.peopleByKennitala).filter(item => item.includes(kennitala))
        let kt = ktNamePair[0][0]
        let name = ktNamePair[0][1]
        return (
            <div className="customer-container">
                <div className="customer">
                    <p>{name}</p>
                    <span>{formatKennitala(kt)}</span>
                </div>
            </div>)
    }

    render() {
        let customers = this.props.customers;
        let contractStatusArr = []
        return (
            <>
                <div className="row">
                    {customers.customerList.map((customer) => {
                        this.state.multIds[customer.Customer.AccountNum] = []
                        let allContracts =
                            <div className="add-id-container" id="accordion">
                                {Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
                                    return (
                                        <>
                                            {this.getCustNameAndKennitala(key)}
                                            <b>Samningar:</b>
                                            {Object.values(value).map((contract) => 

                                                <>
                                                    { contract.map(c => {
                                                        contractStatusArr.push(c.ContractStatusId)
                                                        if (c.ContractStatusId  === 'NÝTT') {
                                                            if(!this.state.multIds[customer.Customer.AccountNum].includes(c.ContractId)){
                                                                this.state.multIds[customer.Customer.AccountNum].push(c.ContractId)
                                                            }
                                                            return (<>
                                                                <div>
                                                                    <div className="contract-type">{getDescriptiveContractName(c.ContractType)} - Samningur númer {c.ContractId}</div>
                                                                </div>
                                                            </>)
                                                        }
                                                    })}
                                                </>
                                            )}
                                            { contractStatusArr.includes("NÝTT") ? 
                                              <ContractsOverviewDetailedContractInfo contract={value} multipleIds={this.state.multIds[customer.Customer.AccountNum]} dispatch={this.props.dispatch} contracts={this.props.contracts}/>
                                               :
                                              <Alert variant="warning">Engir ósamþykktir samningar fundust fyrir viðskiptavin</Alert>
                                            }
                                        </>
                                    )
                                }
                                )}
                            </div>
                        return allContracts;
                    })}
                </div>
            </>
        )
    }
}

AddPhotoId.defaultProps = {
}

export default AddPhotoId;